export const COMPUTER_CHARGES = "Computer Charges";
export const SUBSCRIPTION = "Subscription";
export const COMMUNICATION = "Communication";
export const IT_FEES = "IT Fees";

export const SAVE_CATEGORY_IT = "IT";

export const SAVE_DATA_IT = [
  {
    activity: "OVH",
    theme: [
      { name: COMPUTER_CHARGES, quantity: 1 },
      { name: SUBSCRIPTION, quantity: 1 },
      { name: COMMUNICATION, quantity: 1 },
      { name: IT_FEES, quantity: 1 },
    ],
  },
];
